import { render, staticRenderFns } from "./clientAgeRange.vue?vue&type=template&id=c1f13b8e&scoped=true&"
import script from "./clientAgeRange.vue?vue&type=script&lang=js&"
export * from "./clientAgeRange.vue?vue&type=script&lang=js&"
import style0 from "./clientAgeRange.vue?vue&type=style&index=0&id=c1f13b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f13b8e",
  null
  
)

export default component.exports